export default {
  name: 'ckb',
  el: {
    breadcrumb: {
      label: 'Breadcrumb', // to be translated
    },
    colorpicker: {
      confirm: 'باشە',
      clear: 'پاککردنەوە',
      defaultLabel: 'هەڵبژاردنی ڕەنگ',
      description:
        'ڕەنگی ئێستا {color}. ئینتەر دابگرە بۆ هەڵبژاردنی ڕەنگی نوێ.',
    },
    datepicker: {
      now: 'ئێستا',
      today: 'ئەمڕۆ',
      cancel: 'پەشیمانبوونەوە',
      clear: 'پاککردنەوە',
      confirm: 'باشە',
      dateTablePrompt:
        'کلیلی ئاراستەکان بەکاربهێنەر بۆ هەڵبژاردنی ڕۆژی مانگەکە',
      monthTablePrompt: 'کلیلی ئاراستەکان بەکاربهێنەر بۆ هەڵبژاردنی مانگ',
      yearTablePrompt: 'کلیلی ئاراستەکان بەکاربهێنەر بۆ هەڵبژاردنی ساڵ',
      selectedDate: 'بەرواری هەڵبژێردراو',
      selectDate: 'هەڵبژاردنی بەروار',
      selectTime: 'هەڵبژاردنی کات',
      startDate: 'بەرواری دەستپێک',
      startTime: 'کاتی دەستپێک',
      endDate: 'بەرواری کۆتایی',
      endTime: 'کاتی کۆتایی',
      prevYear: 'ساڵی پێشوو',
      nextYear: 'ساڵ داهاتوو',
      prevMonth: 'مانگی پێشوو',
      nextMonth: 'مانگی داهاتوو',
      year: '',
      month1: 'ڕێبەندان',
      month2: 'ڕەشەمە',
      month3: 'نەورۆز',
      month4: 'گوڵان',
      month5: 'جۆزەردان',
      month6: 'پووشپەڕ',
      month7: 'گەلاوێژ',
      month8: 'خەرمانان',
      month9: 'ڕەزبەر',
      month10: 'گەڵاڕێزان',
      month11: 'سەرماوەز',
      month12: 'بەفرانبار',
      week: 'هەفت',
      weeks: {
        sun: 'یەکشەممە',
        mon: 'دووشەممە',
        tue: 'سێشەممە',
        wed: 'چوارشەممە',
        thu: 'پێنجشەممە',
        fri: 'هەینی',
        sat: 'شەممە',
      },
      weeksFull: {
        sun: 'یەکشەممە',
        mon: 'دووشەممە',
        tue: 'سێشەممە',
        wed: 'چوارشەممە',
        thu: 'پێنجشەممە',
        fri: 'هەینی',
        sat: 'شەممە',
      },
      months: {
        jan: 'ڕێبەندان',
        feb: 'ڕەشەمە',
        mar: 'نەورۆز',
        apr: 'گوڵان',
        may: 'جۆزەردان',
        jun: 'پووشپەڕ',
        jul: 'گەلاوێژ',
        aug: 'خەرمانان',
        sep: 'ڕەزبەر',
        oct: 'گەڵاڕێزان',
        nov: 'سەرماوەز',
        dec: 'بەفرانبار',
      },
    },
    inputNumber: {
      decrease: 'کەمکردنەوەی ژمارە',
      increase: 'زیادکردنی ژمارە',
    },
    select: {
      loading: 'بارکردن',
      noMatch: 'هیچ داتایەکی هاوتا نیە',
      noData: 'هیچ داتایەک نیە',
      placeholder: 'هەڵبژاردن',
    },
    dropdown: {
      toggleDropdown: 'کردنەوەو داخستنی کشاو',
    },
    cascader: {
      noMatch: 'هیچ داتایەکی هاوتا نیە',
      loading: 'بارکردن',
      placeholder: 'هەڵبژاردن',
      noData: 'هیچ داتایەک نیە',
    },
    pagination: {
      goto: 'بڕۆ بۆ',
      pagesize: '/لاپەڕە',
      total: 'کۆی گشتیی {total}',
      pageClassifier: '',
      page: 'Page', // to be translated
      prev: 'Go to previous page', // to be translated
      next: 'Go to next page', // to be translated
      currentPage: 'page {pager}', // to be translated
      prevPages: 'Previous {pager} pages', // to be translated
      nextPages: 'Next {pager} pages', // to be translated
      deprecationWarning:
        'بەکارهێنانی بەکارنەهێنراو دۆزراوەتەوە، تکایە بۆ وردەکاری زیاتر سەردانی بەڵگەنامەکانی el-pagination بکە',
    },
    dialog: {
      close: 'داخستنی ئەم دیالۆگە',
    },
    drawer: {
      close: 'داخستنی ئەم دیالۆگە',
    },
    messagebox: {
      title: 'پەیام',
      confirm: 'باشە',
      cancel: 'پەشایمانبوونەوە',
      error: 'داخلکردنی نایاسایی',
      close: 'داخستنی ئەم دیالۆگە',
    },
    upload: {
      deleteTip: 'فشار لەسەر سڕینەوە بکە بۆ لابردن',
      delete: 'سڕینەوە',
      preview: 'بینینەوە',
      continue: 'بەردەوامبوون',
    },
    slider: {
      defaultLabel: 'سلاید لە نێوان {min} و {max}',
      defaultRangeStartLabel: 'بەهای دەستپێک هەلبژێرە',
      defaultRangeEndLabel: 'بەهای کۆتایی هەلبژێرە',
    },
    table: {
      emptyText: 'هیچ داتا نیە',
      confirmFilter: 'دووپاتکردنەوە',
      resetFilter: 'جێگیرکردنەوە',
      clearFilter: 'هەموو',
      sumText: 'کۆ',
    },
    tree: {
      emptyText: 'هیچ داتا نیە',
    },
    transfer: {
      noMatch: 'هیچ داتای هاوتا نیە',
      noData: 'هیچ داتا نیە',
      titles: ['لیستی 1', 'لیستی 2'], // to be translated
      filterPlaceholder: 'کلیلەوشە داخڵ بکە', // to be translated
      noCheckedFormat: '{total} دانە', // to be translated
      hasCheckedFormat: '{checked}/{total} هەڵبژێردراوە', // to be translated
    },
    image: {
      error: 'شکستی هێنا',
    },
    pageHeader: {
      title: 'گەڕانەوە', // to be translated
    },
    popconfirm: {
      confirmButtonText: 'بەڵێ',
      cancelButtonText: 'نەخێر',
    },
    carousel: {
      leftArrow: 'Carousel arrow left', // to be translated
      rightArrow: 'Carousel arrow right', // to be translated
      indicator: 'Carousel switch to index {index}', // to be translated
    },
  },
}
